import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/**
 * This is actually a workaround, because the required validator triggers by default without even touching the form. To fix this issue,
 * I've added a hidden option that is checked by default, we'll be able to check its value using this validator.
 */
export const touchedRequiredValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    return control.touched && '' === control.value ? {required: true} : null;
}
